import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const CorporatePage: React.FC = () => {
  return <EventPageTemplate {...eventData.corporate} />;
};

export default CorporatePage;